var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { NameKind } from './PowerFxSyntaxTypes';
/** Name used to represent our language */
export var languageName = 'powerfx';
/** Creates an entry for our language with the monaco editor */
export function ensureLanguageRegistered(monacoParam, syntax) {
    var _this = this;
    var _a;
    if (monacoParam.languages.getLanguages().some(function (language) { return language.id === languageName; })) {
        return;
    }
    monacoParam.languages.register({
        id: languageName,
    });
    function refresh(names) {
        monacoParam.languages.setMonarchTokensProvider(languageName, formulaEditorSyntax(syntax.useSemicolons, names));
    }
    refresh(syntax.highlightedNames);
    (_a = syntax.subscribeToNames) === null || _a === void 0 ? void 0 : _a.call(syntax, refresh);
    var getTokenForPosition = function (position, tokens) {
        for (var i = tokens.length - 1; i >= 0; i--) {
            var token = tokens[i];
            if (token.offset <= position.column) {
                return token;
            }
        }
        return null;
    };
    function isPositionAStringToken(position, model) {
        // Get 0'th element since we're tokenizing one line
        var tokens = monacoParam.editor.tokenize(model.getLineContent(position.lineNumber), languageName)[0];
        var token = getTokenForPosition(position, tokens);
        return !!(token && token.type.indexOf('string') === 0);
    }
    monacoParam.languages.registerCompletionItemProvider(languageName, {
        triggerCharacters: ['.', '!', '(', ',', '{'],
        provideCompletionItems: function (model) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, void 0, void 0, function () {
                var completionProvider;
                return __generator(this, function (_a) {
                    if (completionProviderMapping.has(model)) {
                        completionProvider = completionProviderMapping.get(model);
                        return [2 /*return*/, completionProvider.apply(void 0, __spread([model], rest))];
                    }
                    else {
                        return [2 /*return*/, {
                                incomplete: false,
                                suggestions: [],
                            }];
                    }
                    return [2 /*return*/];
                });
            });
        },
    });
    // Register an auto-fix for fixing case of auto-completion items
    monacoParam.languages.registerOnTypeFormattingEditProvider(languageName, {
        autoFormatTriggerCharacters: ['(', '[', '{', ')', ']', '}', ',', ';', '.'],
        provideOnTypeFormattingEdits: function (model, position) {
            if (!syntax.getNormalizedCompletionLookup) {
                return [];
            }
            // Get the token just before the trigger character
            var word = model.getWordUntilPosition(model.modifyPosition(position, -1));
            // Only normalize words that are part of the auto-completion table,
            // don't auto-format casing within strings
            var normalizedWord = word.word.toLowerCase();
            var normalizedCompletionLookup = syntax.getNormalizedCompletionLookup();
            if (normalizedWord in normalizedCompletionLookup && !isPositionAStringToken(position, model)) {
                return [
                    {
                        range: {
                            startLineNumber: position.lineNumber,
                            endLineNumber: position.lineNumber,
                            startColumn: word.startColumn,
                            endColumn: word.endColumn,
                        },
                        text: normalizedCompletionLookup[normalizedWord],
                    },
                ];
            }
            return [];
        },
    });
    monacoParam.languages.registerSignatureHelpProvider(languageName, {
        signatureHelpTriggerCharacters: ['(', ','],
        signatureHelpRetriggerCharacters: ['(', ','],
        provideSignatureHelp: function (model, position, token, context) {
            if (signatureHelpProviderMapping.has(model)) {
                var signatureHelpProvider = signatureHelpProviderMapping.get(model);
                return signatureHelpProvider(model, position, token, context);
            }
            return {
                value: {
                    signatures: [],
                    activeSignature: 0,
                    activeParameter: 0,
                },
                dispose: function () {
                    return;
                },
            };
        },
    });
    monacoParam.languages.registerCodeActionProvider(languageName, {
        provideCodeActions: function (model /** ITextModel */, range /** Range */, context /** CodeActionContext */, token /** CancellationToken */) {
            if (codeActionProviderMapping.has(model)) {
                var codeActionProvider = codeActionProviderMapping.get(model);
                return codeActionProvider(model, range, context, token);
            }
            return {
                actions: [],
                dispose: function () {
                    return;
                },
            };
        },
    });
    // Set language configuration to show matching brackets
    monacoParam.languages.setLanguageConfiguration(languageName, {
        surroundingPairs: [
            { open: '{', close: '}' },
            { open: '[', close: ']' },
            { open: '(', close: ')' },
        ],
        brackets: [
            ['{', '}'],
            ['[', ']'],
            ['(', ')'],
        ],
    });
}
export function formulaEditorSyntax(useSemicolons, names) {
    return {
        booleans: ['true', 'false'],
        keywords: ['ThisItem', 'Self', 'Parent'],
        operators: [
            '+',
            '-',
            '*',
            '/',
            '^',
            '%',
            '=',
            '>',
            '>=',
            '<',
            '<=',
            '<>',
            '&',
            '&&',
            '||',
            '!',
            '.',
            '@',
            ';;',
        ],
        hostSymbols: names.filter(function (name) { return name.kind === NameKind.HostSymbol; }).map(function (name) { return name.name; }),
        variables: names.filter(function (name) { return name.kind === NameKind.Variable; }).map(function (name) { return name.name; }),
        functions: names.filter(function (name) { return name.kind === NameKind.Function; }).map(function (name) { return name.name; }),
        // Captures blocks of symbols that are checked for being operators later.
        symbols: /[=><!~?:&|+\-*\/\^%@;]+/,
        // C# style strings
        escapes: /\\(?:[abfnrtv\\"']|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,
        tokenizer: {
            root: [
                // Record keys must always be plain identifier color.
                [/[a-zA-Z_][\w]*\s*:/, 'identifier'],
                // Identifiers and keywords
                [
                    /[a-zA-Z_][\w]*/,
                    {
                        cases: {
                            '@functions': 'function',
                            '@booleans': 'boolean',
                            '@keywords': 'keyword',
                            '@hostSymbols': 'hostSymbol',
                            '@variables': 'variable',
                            '@default': 'identifier',
                        },
                    },
                ],
                { include: '@whitespace' },
                // Delimiters and operators
                [/[{}()\[\]]/, '@brackets'],
                [/[<>](?!@symbols)/, '@brackets'],
                [
                    /@symbols/,
                    {
                        cases: {
                            '@operators': 'operator',
                            '@default': '',
                        },
                    },
                ],
                // numbers
                [useSemicolons ? /\d*\,\d+([eE][\-+]?\d+)?/ : /\d*\.\d+([eE][\-+]?\d+)?/, 'number.float'],
                [/\d+/, 'number'],
                // delimiter: after number because of .\d floats
                [/[;,.]/, 'delimiter'],
                // strings
                [/"([^"\\]|\\.)*$/, 'string.invalid'],
                [/"/, { token: 'string.quote', bracket: '@open', next: '@string' }],
                [/'([^'\\]|\\.)*$/, 'unicodeIdentifier.invalid'],
                [/'/, { token: 'unicodeIdentifier.quote', bracket: '@open', next: '@unicodeIdentifier' }],
                // Unknown literals (could be unicode names)
                [
                    /.\S*/,
                    {
                        cases: {
                            '@hostSymbols': 'hostSymbol',
                            '@variables': 'variable',
                            '@default': 'identifier',
                        },
                    },
                ],
            ],
            comment: [
                [/[^\/*]+/, 'comment'],
                [/\/\*/, 'comment', '@push'],
                ['\\*/', 'comment', '@pop'],
                [/[\/*]/, 'comment'],
            ],
            string: [
                [/[^\\"]+/, 'string'],
                [/@escapes/, 'string.escape'],
                [/\\./, 'string.escape.invalid'],
                [/"/, { token: 'string.quote', bracket: '@close', next: '@pop' }],
            ],
            unicodeIdentifier: [
                [/[^\\']+/, 'unicodeIdentifier'],
                [/@escapes/, 'unicodeIdentifier.escape'],
                [/\\./, 'unicodeIdentifier.escape.invalid'],
                [/'/, { token: 'unicodeIdentifier.quote', bracket: '@close', next: '@pop' }],
            ],
            whitespace: [
                [/[ \t\r\n]+/, 'white'],
                [/\/\*/, 'comment', '@comment'],
                [/\/\/.*$/, 'comment'],
            ],
        },
    };
}
/**
 * Because the language is a singleton, but our current language service has a completion provider per editor
 * we need to keep a mapping of models to the completion provider implementation to use
 */
var completionProviderMapping = new Map();
var signatureHelpProviderMapping = new Map();
var codeActionProviderMapping = new Map();
/** Registers providers to be used for the specified model */
export function addProvidersForModel(model, completionProvider, signatureHelpProvider, codeActionProvider) {
    if (completionProviderMapping.has(model)) {
        throw new Error('Completion provider already exists for this model.');
    }
    if (signatureHelpProviderMapping.has(model)) {
        throw new Error('SignatureHelp provider already exists for this model.');
    }
    if (codeActionProviderMapping.has(model)) {
        throw new Error('codeActionProvider provider already exists for this model.');
    }
    completionProviderMapping.set(model, completionProvider);
    signatureHelpProviderMapping.set(model, signatureHelpProvider);
    codeActionProviderMapping.set(model, codeActionProvider);
    return {
        dispose: function () {
            completionProviderMapping.delete(model);
            signatureHelpProviderMapping.delete(model);
            codeActionProviderMapping.delete(model);
        },
    };
}
//# sourceMappingURL=PowerFxSyntax.js.map